<template>
  <div>
    <b-input-group>
      <b-form-input
        id="input-staff-select-title"
        size="sm"
        :disabled="this.$props.isDisabled"
        v-model="query"
        placeholder="Персонал"
        autocomplete="off"
        @focus="onFocusIn"
        @blur="onFocusOut"/>

      <b-input-group-append>
        <b-button size="sm" :disabled="!query || this.$props.isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-input" v-if="isFocus">
        <b-list-group-item
          v-for="(item, index) in items"
          :key="index"
          @mousedown="onClick(item)"
          button
          class="text-small"
        >
          {{ getItemListText(item) }}
        </b-list-group-item>
      </b-list-group>
    </b-input-group>
  </div>
</template>

<script>
import staff from "../../network/staff";

export default {
  name: "StaffSelect",
  mixins: [ staff ],
  props: {
    isDisabled: Boolean,
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      item: null
    }
  },
  methods: {
    async configure(id) {
      if (id > 0) {
        const staff = (await this.getStaffById(id)).data;
        if (staff != null) {
          this.query = this.getShortName(staff.surname, staff.name, staff.patronymic);
          this.item = staff;
          return;
        }
      }

      this.query = "";
      this.item = null;
      this.items = await this.getItems(this.query);
    },
    async onFocusIn() {
      if (this.query === "" && this.items.length === 0) {
        this.items = await this.getItems(this.query);
      }
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;
    },
    onClear() {
      this.query = "";
      this.item = null;
      this.$emit('onSelect', 0);
    },
    async onClick(item) {
      this.query = this.getShortName(item.surname, item.name, item.patronymic);
      const staff = (await this.getStaffById(item.id)).data;
      if (staff != null) {
        this.item = staff;
      } else {
        this.item = item;
      }
      this.$emit('onSelect', item.id);
    },
    getItemListText(item) {
      return this.getShortName(item.surname, item.name, item.patronymic);
    },
    async getItems(query) {
      const result = await this.getStaffsSearch(query);
      if (result.data != null) {
        return result.data;
      } else {
        return [];
      }
    },
    getShortName(surname, name, patronymic) {
      const firstCharName = name.slice(0,1);
      const firstCharPatronymic = patronymic.slice(0,1);
      if (firstCharPatronymic === '') {
        return `${surname} ${firstCharName}.`;
      }
      return `${surname} ${firstCharName}. ${firstCharPatronymic}.`;
    },
  },
  watch: {
    'query': {
      handler: async function () {
        if (this.query != null) {
          const queryLower = this.query.toLowerCase();
          this.items = await this.getItems(queryLower);
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Staff/StaffSelect.vue